import SMELogo from "@assets/logo-sme.svg";
import aseanBusinessLogo from "@assets/verticals/asean-logo-black.svg";
import internationalGlobalLogo from "@assets/verticals/international-global-logo-blue.svg";

export const ASEAN_DESCRIPTION =
  "Your go-to portal for up-to-date business guides, information, and resources for all businesses and investors with an interest in ASEAN.";
export const SGSME_DESCRIPTION =
  "A news-driven repository of information and knowledge for Singapore's SMEs";
export const GLOBAL_DESCRIPTION =
  "Everything you need to know about Global Enterprise and the people behind them.";

export const VERTICAL_MASTHEADS = {
  global: {
    alt: "Global Enterprise logo",
    src: internationalGlobalLogo,
    width: 150,
    height: 50,
  },
  asean: {
    alt: "Asean Business logo",
    src: aseanBusinessLogo,
    width: 240,
    height: 57,
  },
  sme: {
    alt: "SGSME logo",
    src: SMELogo,
    width: 126,
    height: 31,
  },
};
